import { useEffect, useState } from 'react';
import { FiCalendar, FiGithub, FiGlobe, FiLinkedin, FiMapPin, FiTwitter, FiUser, FiYoutube } from 'react-icons/fi';
import { RESOLVE_PORTFOLIO_MEDIA_URL } from '../../../_Shared/resolveMediaUrl';

const SOCIAL_ICONS = { github: FiGithub, linkedin: FiLinkedin, twitter: FiTwitter, 'twitter-x': FiTwitter, youtube: FiYoutube, web: FiGlobe };

const ProfileAvatar = ({ photo, name }) => {
    const src = RESOLVE_PORTFOLIO_MEDIA_URL(photo);
    const [failed, setFailed] = useState(false);

    useEffect(() => { setFailed(false); }, [src]);

    if (!src || failed) return <FiUser aria-label="Sin foto de perfil" />;

    return (
        <img
            src={src}
            alt={name || 'Perfil'}
            onError={() => setFailed(true)}
        />
    );
};

export const ProfileSpotlight = ({ profile = {}, socials = [] }) => {
    const hasPhoto = !!RESOLVE_PORTFOLIO_MEDIA_URL(profile.photo);

    return (
        <section className="PB__profile_spotlight" aria-label="Perfil profesional">
            <div className="PB__container PB__profile_spotlight_inner">
                <aside className="PB__profile_card PB__profile_card--spotlight">
                    <div className="PB__profile_head PB__profile_head--spotlight">
                        <div className={`PB__avatar PB__avatar--spotlight ${hasPhoto ? 'has-photo' : ''}`}>
                            <ProfileAvatar photo={profile.photo} name={profile.name} />
                        </div>
                        <div className="PB__profile_identity">
                            <span className="PB__profile_mini_kicker">Perfil profesional</span>
                            <h2>{profile.name || 'Gastón'}</h2>
                            <p>{profile.role || 'Full-stack Developer'}</p>
                        </div>
                    </div>

                    <div className="PB__profile_divider PB__profile_divider--spotlight" />

                    <div className="PB__info_grid PB__info_grid--spotlight">
                        <div>
                            <FiMapPin />
                            <span><b>Ubicación</b>{profile.location || '-'}</span>
                        </div>
                        <div>
                            <FiGlobe />
                            <span><b>Web</b>{profile.website || '-'}</span>
                        </div>
                        <div>
                            <FiGlobe />
                            <span><b>Idiomas</b>{profile.languages || '-'}</span>
                        </div>
                        <div>
                            <FiCalendar />
                            <span><b>Disponible</b>{profile.availability || '-'}</span>
                        </div>
                        {socials.length > 0 && (
                            <div className="PB__profile_socials" aria-label="Redes sociales">
                                {socials.map((social) => {
                                    const Icon = SOCIAL_ICONS[String(social.network || '').toLowerCase()] || FiGlobe;
                                    return (
                                        <a key={social.id || social.network || social.url} href={social.url} target="_blank" rel="noreferrer">
                                            <Icon />
                                            <span>{social.label || social.network || 'Red'}</span>
                                        </a>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </aside>
            </div>
        </section>
    );
};
